import { AABBModel } from './AABBModel';


export enum MiniGameTypeEnum {
    none = '100',
    ropes = 'ropes',
    anchor = 'anchor',
    boat = 'boat',
    wheel = 'wheel',
    task = 'task',
    laser = 'laser',
    fuel = 'fuel',
    engine = 'engine',
    props = 'props',
    rescue = 'rescue',
    departure = 'departure',
    find_boat = 'find_boat'
}

export class MiniGameModel extends AABBModel {
    public visible: boolean = false;
    public key: string = '';
    public index: number = 0;

    public selected: boolean = false;
    public completed: boolean = false;
    public failed: boolean = false;

    public screenPos: [number, number] = [0, 0];

    public constructor(public type: MiniGameTypeEnum) {
        super();

        this.height = 200;
        this.width = 300;
    }

    get aabb(): [number, number, number, number] {
        return [
            this.pos[0],// - this.width / 2,
            this.pos[1] - this.height/2,
            this.width,
            this.height,
        ];
    }
}
